import React from "react";

type Props = {
  children: React.ReactNode;
};

export const FormHeader = ({ children }: Props) => {
  return (
    <p className="text-left text-XXXLarge font-bold leading-tight text-gray-600">
      {children}
    </p>
  );
};
